export default "__VITE_ASSET__BghEsCbn__"